<template>
  <div class="MdBx"
    :class="[
      layoutClass,
      marginClass,
      box.position === 'absolute' ? 'ExAbs' : '',
      flexClass,
      borderClass,
      borderRadiusClass,
      spacingClass,
      justifyContentClass,
      alignItemsClass,
      offsetTopClass,
      offsetBottomClass,
      offsetStartClass,
      offsetEndClass,
      paddingAllClass,
      paddingTopClass,
      paddingBottomClass,
      paddingStartClass,
      paddingEndClass,
      hoverPath === parentPath + 'box' ? 'on-hover' : ''
    ]"
    :style="styles"
  >
    <template v-for="(item, index) in box.contents" :key="index">
      <FlexMessageComponents
        :type="item.type"
        :component="item"
        :parentLayout="box.layout"
        :parentSpacing="box.spacing"
        :direction="direction"
        :parentPath="parentPath + 'box-' + index + '.'"
        :hoverPath="hoverPath"
        :editPath="editPath"
        :isAdmin="isAdmin"
        @onSelectNode="selectNode"
        @initListNode="initListNode"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBox } from '@/utils/types'
import Video from '@/components/common/flex-message/components/Video.vue'

@Options({
  components: { Video },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class Box extends Vue {
  @Prop()
  box!: IFlexMessageBox

  @Prop()
  parentLayout!: string

  @Prop()
  parentSpacing!: string

  @Prop()
  direction!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  get layoutClass() {
    if (this.box.layout === 'baseline') {
      return 'hr bl'
    } else if (this.box.layout === 'horizontal') {
      return 'hr'
    } else {
      return 'vr'
    }
  }

  get spacingClass() {
    if (this.box.spacing === 'xs') {
      return 'spcXs'
    } else if (this.box.spacing === 'sm') {
      return 'spcSm'
    } else if (this.box.spacing === 'md') {
      return 'spcMd'
    } else if (this.box.spacing === 'lg') {
      return 'spcLg'
    } else if (this.box.spacing === 'xl') {
      return 'spcXl'
    } else if (this.box.spacing === 'xxl') {
      return 'spcXXl'
    } else {
      return ''
    }
  }

  get marginClass() {
    if (this.parentLayout === 'horizontal' || this.parentLayout === 'baseline') {
      if (this.direction === 'rtl') {
        if (this.box.margin === 'none') {
          return 'ExMgnRNone'
        } else if (this.box.margin === 'xs') {
          return 'ExMgnRXs'
        } else if (this.box.margin === 'sm') {
          return 'ExMgnRSm'
        } else if (this.box.margin === 'md') {
          return 'ExMgnRMd'
        } else if (this.box.margin === 'lg') {
          return 'ExMgnRLg'
        } else if (this.box.margin === 'xl') {
          return 'ExMgnRXl'
        } else if (this.box.margin === 'xxl') {
          return 'ExMgnRXXl'
        }
      } else {
        if (this.box.margin === 'none') {
          return 'ExMgnLNone'
        } else if (this.box.margin === 'xs') {
          return 'ExMgnLXs'
        } else if (this.box.margin === 'sm') {
          return 'ExMgnLSm'
        } else if (this.box.margin === 'md') {
          return 'ExMgnLMd'
        } else if (this.box.margin === 'lg') {
          return 'ExMgnLLg'
        } else if (this.box.margin === 'xl') {
          return 'ExMgnLXl'
        } else if (this.box.margin === 'xxl') {
          return 'ExMgnLXXl'
        }
      }
    } else {
      if (this.box.margin === 'none') {
        return 'ExMgnTNone'
      } else if (this.box.margin === 'xs') {
        return 'ExMgnTXs'
      } else if (this.box.margin === 'sm') {
        return 'ExMgnTSm'
      } else if (this.box.margin === 'md') {
        return 'ExMgnTMd'
      } else if (this.box.margin === 'lg') {
        return 'ExMgnTLg'
      } else if (this.box.margin === 'xl') {
        return 'ExMgnTXl'
      } else if (this.box.margin === 'xxl') {
        return 'ExMgnTXXl'
      }
    }
  }

  get borderClass() {
    if (this.box.borderWidth === 'none') {
      return 'ExBdrWdtNone'
    } else if (this.box.borderWidth === 'light') {
      return 'ExBdrWdtLgh'
    } else if (this.box.borderWidth === 'normal') {
      return 'ExBdrWdtNml'
    } else if (this.box.borderWidth === 'medium') {
      return 'ExBdrWdtMdm'
    } else if (this.box.borderWidth === 'semi-bold') {
      return 'ExBdrWdtSbd'
    } else if (this.box.borderWidth === 'bold') {
      return 'ExBdrWdtBld'
    } else {
      return ''
    }
  }

  get borderRadiusClass() {
    if (this.box.cornerRadius === 'none') {
      return 'ExBdrRadNone'
    } else if (this.box.cornerRadius === 'xs') {
      return 'ExBdrRadXs'
    } else if (this.box.cornerRadius === 'sm') {
      return 'ExBdrRadSm'
    } else if (this.box.cornerRadius === 'md') {
      return 'ExBdrRadMd'
    } else if (this.box.cornerRadius === 'lg') {
      return 'ExBdrRadLg'
    } else if (this.box.cornerRadius === 'xl') {
      return 'ExBdrRadXl'
    } else if (this.box.cornerRadius === 'xxl') {
      return 'ExBdrRadXXl'
    } else {
      return ''
    }
  }

  get justifyContentClass() {
    if (this.box.justifyContent === 'center') {
      return 'itms-jfcC'
    } else if (this.box.justifyContent === 'flex-start') {
      return 'itms-jfcS'
    } else if (this.box.justifyContent === 'flex-end') {
      return 'itms-jfcE'
    } else if (this.box.justifyContent === 'space-between') {
      return 'itms-jfcSB'
    } else if (this.box.justifyContent === 'space-around') {
      return 'itms-jfcSA'
    } else if (this.box.justifyContent === 'space-evenly') {
      return 'itms-jfcSE'
    } else {
      return ''
    }
  }

  get alignItemsClass() {
    if (this.box.alignItems === 'flex-start') {
      return 'itms-algS'
    } else if (this.box.alignItems === 'flex-end') {
      return 'itms-algE'
    } else if (this.box.alignItems === 'center') {
      return 'itms-algC'
    } else if (this.box.alignItems === 'baseline') {
      return 'itms-algBL'
    } else if (this.box.alignItems === 'stretch') {
      return 'itms-algSR'
    } else {
      return ''
    }
  }

  get offsetTopClass() {
    if (this.box.offsetTop === 'none') {
      return 'ExTNone'
    } else if (this.box.offsetTop === 'xs') {
      return 'ExTXs'
    } else if (this.box.offsetTop === 'sm') {
      return 'ExTSm'
    } else if (this.box.offsetTop === 'md') {
      return 'ExTMd'
    } else if (this.box.offsetTop === 'lg') {
      return 'ExTLg'
    } else if (this.box.offsetTop === 'xl') {
      return 'ExTXl'
    } else if (this.box.offsetTop === 'xxl') {
      return 'ExTXXl'
    } else {
      return ''
    }
  }

  get offsetBottomClass() {
    if (this.box.offsetBottom === 'none') {
      return 'ExBNone'
    } else if (this.box.offsetBottom === 'xs') {
      return 'ExBXs'
    } else if (this.box.offsetBottom === 'sm') {
      return 'ExBSm'
    } else if (this.box.offsetBottom === 'md') {
      return 'ExBMd'
    } else if (this.box.offsetBottom === 'lg') {
      return 'ExBLg'
    } else if (this.box.offsetBottom === 'xl') {
      return 'ExBXl'
    } else if (this.box.offsetBottom === 'xxl') {
      return 'ExBXXl'
    } else {
      return ''
    }
  }

  get offsetStartClass() {
    if (this.direction === 'rtl') {
      if (this.box.offsetStart === 'none') {
        return 'ExRNone'
      } else if (this.box.offsetStart === 'xs') {
        return 'ExRXs'
      } else if (this.box.offsetStart === 'sm') {
        return 'ExRSm'
      } else if (this.box.offsetStart === 'md') {
        return 'ExRMd'
      } else if (this.box.offsetStart === 'lg') {
        return 'ExRLg'
      } else if (this.box.offsetStart === 'xl') {
        return 'ExRXl'
      } else if (this.box.offsetStart === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    } else {
      if (this.box.offsetStart === 'none') {
        return 'ExLNone'
      } else if (this.box.offsetStart === 'xs') {
        return 'ExLXs'
      } else if (this.box.offsetStart === 'sm') {
        return 'ExLSm'
      } else if (this.box.offsetStart === 'md') {
        return 'ExLMd'
      } else if (this.box.offsetStart === 'lg') {
        return 'ExLLg'
      } else if (this.box.offsetStart === 'xl') {
        return 'ExLXl'
      } else if (this.box.offsetStart === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    }
  }

  get offsetEndClass() {
    if (this.direction === 'rtl') {
      if (this.box.offsetEnd === 'none') {
        return 'ExLNone'
      } else if (this.box.offsetEnd === 'xs') {
        return 'ExLXs'
      } else if (this.box.offsetEnd === 'sm') {
        return 'ExLSm'
      } else if (this.box.offsetEnd === 'md') {
        return 'ExLMd'
      } else if (this.box.offsetEnd === 'lg') {
        return 'ExLLg'
      } else if (this.box.offsetEnd === 'xl') {
        return 'ExLXl'
      } else if (this.box.offsetEnd === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    } else {
      if (this.box.offsetEnd === 'none') {
        return 'ExRNone'
      } else if (this.box.offsetEnd === 'xs') {
        return 'ExRXs'
      } else if (this.box.offsetEnd === 'sm') {
        return 'ExRSm'
      } else if (this.box.offsetEnd === 'md') {
        return 'ExRMd'
      } else if (this.box.offsetEnd === 'lg') {
        return 'ExRLg'
      } else if (this.box.offsetEnd === 'xl') {
        return 'ExRXl'
      } else if (this.box.offsetEnd === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    }
  }

  get paddingAllClass() {
    if (this.box.paddingAll === 'none') {
      return 'ExPadANone'
    } else if (this.box.paddingAll === 'xs') {
      return 'ExPadAXs'
    } else if (this.box.paddingAll === 'sm') {
      return 'ExPadASm'
    } else if (this.box.paddingAll === 'md') {
      return 'ExPadAMd'
    } else if (this.box.paddingAll === 'lg') {
      return 'ExPadALg'
    } else if (this.box.paddingAll === 'xl') {
      return 'ExPadAXl'
    } else if (this.box.paddingAll === 'xxl') {
      return 'ExPadAXXl'
    } else {
      return ''
    }
  }

  get paddingTopClass() {
    if (this.box.paddingTop === 'none') {
      return 'ExPadTNone'
    } else if (this.box.paddingTop === 'xs') {
      return 'ExPadTXs'
    } else if (this.box.paddingTop === 'sm') {
      return 'ExPadTSm'
    } else if (this.box.paddingTop === 'md') {
      return 'ExPadTMd'
    } else if (this.box.paddingTop === 'lg') {
      return 'ExPadTLg'
    } else if (this.box.paddingTop === 'xl') {
      return 'ExPadTXl'
    } else if (this.box.paddingTop === 'xxl') {
      return 'ExPadTXXl'
    } else {
      return ''
    }
  }

  get paddingBottomClass() {
    if (this.box.paddingBottom === 'none') {
      return 'ExPadBNone'
    } else if (this.box.paddingBottom === 'xs') {
      return 'ExPadBXs'
    } else if (this.box.paddingBottom === 'sm') {
      return 'ExPadBSm'
    } else if (this.box.paddingBottom === 'md') {
      return 'ExPadBMd'
    } else if (this.box.paddingBottom === 'lg') {
      return 'ExPadBLg'
    } else if (this.box.paddingBottom === 'xl') {
      return 'ExPadBXl'
    } else if (this.box.paddingBottom === 'xxl') {
      return 'ExPadBXXl'
    } else {
      return ''
    }
  }

  get paddingStartClass() {
    if (this.direction === 'rtl') {
      if (this.box.paddingStart === 'none') {
        return 'ExPadRNone'
      } else if (this.box.paddingStart === 'xs') {
        return 'ExPadRXs'
      } else if (this.box.paddingStart === 'sm') {
        return 'ExPadRSm'
      } else if (this.box.paddingStart === 'md') {
        return 'ExPadRMd'
      } else if (this.box.paddingStart === 'lg') {
        return 'ExPadRLg'
      } else if (this.box.paddingStart === 'xl') {
        return 'ExPadRXl'
      } else if (this.box.paddingStart === 'xxl') {
        return 'ExPadRXXl'
      } else {
        return ''
      }
    } else {
      if (this.box.paddingStart === 'none') {
        return 'ExPadLNone'
      } else if (this.box.paddingStart === 'xs') {
        return 'ExPadLXs'
      } else if (this.box.paddingStart === 'sm') {
        return 'ExPadLSm'
      } else if (this.box.paddingStart === 'md') {
        return 'ExPadLMd'
      } else if (this.box.paddingStart === 'lg') {
        return 'ExPadLLg'
      } else if (this.box.paddingStart === 'xl') {
        return 'ExPadLXl'
      } else if (this.box.paddingStart === 'xxl') {
        return 'ExPadLXXl'
      } else {
        return ''
      }
    }
  }

  get paddingEndClass() {
    if (this.direction === 'rtl') {
      if (this.box.paddingEnd === 'none') {
        return 'ExPadLNone'
      } else if (this.box.paddingEnd === 'xs') {
        return 'ExPadLXs'
      } else if (this.box.paddingEnd === 'sm') {
        return 'ExPadLSm'
      } else if (this.box.paddingEnd === 'md') {
        return 'ExPadLMd'
      } else if (this.box.paddingEnd === 'lg') {
        return 'ExPadLLg'
      } else if (this.box.paddingEnd === 'xl') {
        return 'ExPadLXl'
      } else if (this.box.paddingEnd === 'xxl') {
        return 'ExPadLXXl'
      } else {
        return ''
      }
    } else {
      if (this.box.paddingEnd === 'none') {
        return 'ExPadRNone'
      } else if (this.box.paddingEnd === 'xs') {
        return 'ExPadRXs'
      } else if (this.box.paddingEnd === 'sm') {
        return 'ExPadRSm'
      } else if (this.box.paddingEnd === 'md') {
        return 'ExPadRMd'
      } else if (this.box.paddingEnd === 'lg') {
        return 'ExPadRLg'
      } else if (this.box.paddingEnd === 'xl') {
        return 'ExPadRXl'
      } else if (this.box.paddingEnd === 'xxl') {
        return 'ExPadRXXl'
      } else {
        return ''
      }
    }
  }

  get flexClass() {
    if (this.box.flex === 0) {
      return 'fl0'
    } else if (this.box.flex === 1) {
      return 'fl1'
    } else if (this.box.flex === 2) {
      return 'fl2'
    } else if (this.box.flex === 3) {
      return 'fl3'
    }
    return ''
  }

  get styles() {
    const boxStyles: Record<string, string|number|undefined> = {}

    if (this.box.margin && this.box.margin.includes('px')) {
      if (this.parentLayout === 'vertical') {
        boxStyles.marginTop = this.box.margin
      } else {
        boxStyles.marginLeft = this.box.margin
      }
    }
    if (this.parentSpacing && this.parentSpacing.includes('px')) {
      if (this.parentLayout === 'vertical') {
        boxStyles.marginTop = this.parentSpacing
      } else {
        boxStyles.marginLeft = this.parentSpacing
      }
    }
    boxStyles.flexGrow = this.box.flex
    boxStyles.width = this.box.width
    boxStyles.height = this.box.height
    boxStyles.maxWidth = this.box.maxWidth
    boxStyles.maxHeight = this.box.maxHeight
    boxStyles.backgroundColor = this.box.backgroundColor
    if (this.box.borderWidth && this.box.borderWidth.includes('px')) {
      boxStyles.borderWidth = this.box.borderWidth
    }
    boxStyles.borderColor = this.box.borderColor
    if (this.box.cornerRadius && this.box.cornerRadius.includes('px')) {
      boxStyles.borderRadius = this.box.cornerRadius
    }
    if (this.box.offsetTop && (this.box.offsetTop.includes('px') || this.box.offsetTop.includes('%'))) {
      boxStyles.top = this.box.offsetTop
    }
    if (this.box.offsetBottom && (this.box.offsetBottom.includes('px') || this.box.offsetBottom.includes('%'))) {
      boxStyles.bottom = this.box.offsetBottom
    }
    if (this.box.offsetStart && (this.box.offsetStart.includes('px') || this.box.offsetStart.includes('%'))) {
      if (this.direction === 'rtl') {
        boxStyles.right = this.box.offsetStart
      } else {
        boxStyles.left = this.box.offsetStart
      }
    }
    if (this.box.offsetEnd && (this.box.offsetEnd.includes('px') || this.box.offsetEnd.includes('%'))) {
      if (this.direction === 'rtl') {
        boxStyles.left = this.box.offsetEnd
      } else {
        boxStyles.right = this.box.offsetEnd
      }
    }
    if (this.box.paddingAll && (this.box.paddingAll.includes('px') || this.box.paddingAll.includes('%'))) {
      boxStyles.padding = this.box.paddingAll
    }
    if (this.box.paddingTop && (this.box.paddingTop.includes('px') || this.box.paddingTop.includes('%'))) {
      boxStyles.paddingTop = this.box.paddingTop
    }
    if (this.box.paddingBottom && (this.box.paddingBottom.includes('px') || this.box.paddingBottom.includes('%'))) {
      boxStyles.paddingBottom = this.box.paddingBottom
    }
    if (this.box.paddingStart && (this.box.paddingStart.includes('px') || this.box.paddingStart.includes('%'))) {
      if (this.direction === 'rtl') {
        boxStyles.paddingRight = this.box.paddingStart
      } else {
        boxStyles.paddingLeft = this.box.paddingStart
      }
    }
    if (this.box.paddingEnd && (this.box.paddingEnd.includes('px') || this.box.paddingEnd.includes('%'))) {
      if (this.direction === 'rtl') {
        boxStyles.paddingLeft = this.box.paddingEnd
      } else {
        boxStyles.paddingRight = this.box.paddingEnd
      }
    }
    if (this.box.background) {
      if (this.box.background.centerColor) {
        boxStyles.background = `linear-gradient(${this.box.background.angle}, ${this.box.background.startColor} 0%, ${this.box.background.centerColor} ${this.box.background.centerPosition ?? '50%'}, ${this.box.background.endColor} 100%)`
      } else {
        boxStyles.background = `linear-gradient(${this.box.background.angle}, ${this.box.background.startColor} 0%, ${this.box.background.endColor} 100%)`
      }
    }

    return boxStyles
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.$emit('initListNode', path)
  }

  beforeCreate() {
    this.$options.components!.FlexMessageComponents = require('@/components/common/flex-message/FlexMessageComponents.vue').default
  }
}
</script>

<style scoped lang="scss">

</style>
